import styled from 'styled-components/macro';
import { FlexContainer } from '../flex';

export const Form = styled(FlexContainer.withComponent('form'))`
  flex-direction: column;
`;
